<!-- <div class="wl-logo"> -->
<p-progressSpinner class="flex justify-content-center" *ngIf="paramChave && loadingEmpresa"></p-progressSpinner>
<img alt="Card" src="https://oticom.com.br/images/layout/logo.png" *ngIf="!paramChave || (!logoBase64 && !loadingEmpresa)" />
<img alt="Card" [src]="logo" *ngIf="!!logoBase64" />
<!-- </div> -->